import styled from 'styled-components';

export const ResultContent = styled.div`
  img {
    width: 80px;
    margin: 32px 0;
  }
  p {
    padding-bottom: 16px;
    text-align: center;
    font-size: 16px;
    color: #0f438a;
  }
  h4 {
    font-size: 23px;
    padding-bottom: 24px;
    line-height: 100%;
    text-align: center;
    color: #0f438a;
  }
  ul {
    text-align: left;
    list-style-type: disc !important;
  }
`;

export const ResultSearchCertificate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 32px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 50px;
  padding-right: 50px;
  max-width: 1280px;
  @media screen and (max-width: 959px) {
    width: 80%;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const WrapperButtonCertificate = styled.div`
  display: inline-flex;
  gap: 12px;
  flex-flow: row wrap;
  justify-content: space-between;
  @media screen and (max-width: 959px) {
    flex-direction: column;
    margin-bottom: 48px;
  }
  button {
    margin-top: 16px;
    margin-right: 16px;
    @media screen and (max-width: 959px) {
      margin-right: 0;
      width: 240px;
    }
  }
`;

export const ContentCertificate = styled.div`
  p {
    padding-bottom: 16px;
    text-align: center;
    color: #0f438a;
    vertical-align: baseline;
    font-size: 1em;
    line-height: 1.46em;
    font-family: Lato, 'Open Sans', 'Helvetica Neue', Helvetica, Arial,
      sans-serif;
  }
  strong, b {
    font-weight: bold;
  }
  i {
    font-style: italic;
  }
`;
